import React, { FC } from 'react'
import { ConfigParamsContext, useConfigParamsContextProvider } from '../../lib/config'

export const ConfigParamsContextProvider: FC = ({ children }) => {
  const state = useConfigParamsContextProvider()

  return <ConfigParamsContext.Provider value={state}>{children}</ConfigParamsContext.Provider>
}
